module.exports = __webpack_public_path__ + "static/report-3dfc0cc010d967d85113ace1810cf6c8.jpg";